import { useState } from 'react';

const faqs = [
  {
    q: '《帐篷里的秘密》漫画在哪里可以免费阅读？',
    a: '打开5177漫画网首页，点击"立即免费阅读"按钮即可进入《帐篷里的秘密》漫画详情页，支持从第1话开始在线阅读全集中文故事，完全免费，无需注册。',
  },
  {
    q: '5177漫画网的韩漫需要付费吗？',
    a: '不需要。5177漫画网全站韩国漫画均免费阅读，包括《帐篷里的秘密》《温柔禁区》等热门韩漫作品，所有章节均可直接在线浏览，无任何隐藏收费。',
  },
  {
    q: '漫画多久更新一次？',
    a: '热门连载作品每日更新，一般于每日凌晨同步最新话；完结作品已收录全部章节，随时可以一口气看完。更新动态可在首页"最新更新"板块查看。',
  },
  {
    q: '如何在手机上阅读漫画？',
    a: '5177漫画网支持手机、平板、电脑等多端访问，直接使用浏览器打开即可自适应阅读。阅读页面支持上下滚动浏览和章节切换，体验流畅。',
  },
  {
    q: '漫画可以下载离线观看吗？',
    a: '当前为在线免费阅读模式，建议在有网络的环境下浏览。收藏到浏览器书签后，可以快速回到上次阅读的位置，章节列表会记录你的阅读进度。',
  },
  {
    q: '遇到漫画打不开怎么办？',
    a: '可以先尝试刷新页面或更换浏览器。若问题依旧，可通过页面底部的邮箱与我们联系，我们会第一时间处理并反馈，确保你的阅读体验不受影响。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <h2 className="flex items-center justify-center gap-2 font-display text-2xl md:text-3xl">
            <span className="text-accent-500">
              <i className="ri-question-answer-line text-2xl md:text-3xl" aria-hidden="true" />
            </span>
            阅读指南 · 常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            关于免费阅读、更新节奏与使用方式，这里都有答案
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? 'border-primary-200 bg-primary-50/40' : 'border-background-200 bg-background-100'
                }`}
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base font-medium text-foreground-900">{faq.q}</h3>
                  <i
                    className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} shrink-0 text-lg text-primary-600`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <p className="px-5 pb-4 text-sm leading-6 md:leading-7 text-foreground-700 animate-fade-in">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}